export enum MessageDisplay{
    show, 
    hide
}